import { roles } from 'src/config/roles-config'
import { useAuthStore } from 'src/stores/auth'
import { useResultSharingLinkStore } from 'src/stores/shareableLink'
import { createRouter, createWebHistory } from 'vue-router'
import { stageTrackingGuard } from './guards/stageTracking'
import routes from './routes/index'

const router = createRouter({
  history: createWebHistory(),
  routes
})

router.beforeEach(async (to, from, next) => {
  const authStore = useAuthStore()
  const shareableLinkStore = useResultSharingLinkStore()

  let isTokenSet = authStore.isTokenSet || !!localStorage.getItem('token')
  let isOrgSelected = !!(authStore.organization || localStorage.getItem('organization'))
  let sessionKey = localStorage.getItem('sessionKey')
  let role = authStore.role || localStorage.getItem('role')

  let isLoggedIn = isTokenSet && isOrgSelected

  if (isTokenSet && to.path.includes('/reset-password/')) {
    authStore.clearAllStates()
    localStorage.clear()
    isTokenSet = false
    sessionKey = null
    role = null
    next()
  }

  if (isLoggedIn && !sessionKey) {
    authStore.clearState()
    next()
  }

  if (to.path === '/') {
    return redirectToAccuratePath(role, next)
  }
  if (to.path.endsWith('time-studies')) {
    return next({ name: 'studies' })
  }
  if (to.path.endsWith('floor-layout')) {
    return next({ name: 'cellStudies' })
  }
  if (to.path.endsWith('line-balancing')) {
    return next({ name: 'Lines' })
  }
  if (to.path.endsWith('work-instructions')) {
    return next({ name: 'workStudies' })
  }
  if (to.path.endsWith('ergonomics')) {
    return next({ name: 'Assessments' })
  }
  if (to.path.endsWith('fmea')) {
    return next({ name: 'FMEA Records' })
  }
  // redirect to login page if not logged in and try access protected route
  if (!isUnprotectedRoute(to) && !isLoggedIn) {
    // check if user has provided a shareable link token
    if (shareableLinkStore.isShareableTokenUser) {
      if (!shareableLinkStore.isPasswordRequired) {
        shareableLinkStore.isTokenAccessVerified = true
        next()
      }
      if (shareableLinkStore.isTokenAccessVerified) {
        next()
      } else {
        return next({
          name: 'Verify Share Token',
          query: { token: shareableLinkStore.token, redirectTo: window.location, password_required: 'true' }
        })
      }
    }
    // otherwise take user to login page
    authStore.clearState()
    next({ name: 'Login' })
  }

  // redirect to home page when user logged-in and tries to go to protected routes
  if (isLoggedIn && isUnprotectedRoute(to)) {
    return redirectToAccuratePath(role, next)
  }

  // Module access guard: block routes the org hasn't subscribed to
  const moduleCode = to.matched.find((r) => r.meta?.moduleCode)?.meta?.moduleCode
  if (moduleCode && isLoggedIn) {
    if (authStore.orgModules === null) {
      await authStore.fetchOrgModules()
    }
    // [] means no restriction is configured; null (failed fetch) blocks
    const { orgModules } = authStore
    const isAllowed = orgModules?.length === 0 || !!orgModules?.some((m) => m.code === moduleCode)
    if (!isAllowed) return next({ name: 'Home' })
  }

  next()
})

router.afterEach(stageTrackingGuard)

function redirectToAccuratePath(role, next) {
  switch (role) {
    case roles.admin:
      return next({ name: 'Admin Layout' })
    case roles.user:
    case roles.org_user:
    case roles.support_user:
      if (localStorage.getItem('organization')) return next({ name: 'Home' })
      else return next({ name: 'Login' })
    default:
      return next({ name: 'Login' })
  }
}

function isUnprotectedRoute(to) {
  return ['/login', '/signup', '/forgot-password', '/reset-password', '/verify-share/token'].some(
    (url) => to.path.includes(url)
  )
}
// function isValidRole(role) {
//   if (!Object.values(roles).includes(role)) {
//     // store.dispatch('clearState');
//     return false
//   }
//   return true
// }

export default router
